export const IconBackArrow: {
  name: 'icon_back_arrow-a59786fbfd07'
} = {
  name: 'icon_back_arrow-a59786fbfd07'
}
